import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["header", "content", "icon", "label"]

  get storageKey() {
    return "learning-video-collapsed"
  }

  connect() {
    // Restore saved state on page load (use requestAnimationFrame to ensure DOM is ready)
    requestAnimationFrame(() => {
      const isCollapsed = localStorage.getItem(this.storageKey) === "true"
      if (isCollapsed) {
        this.applyCollapsedState()
      }
    })
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    const isCurrentlyCollapsed = this.hasContentTarget && this.contentTarget.classList.contains("collapsed")

    if (isCurrentlyCollapsed) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  collapse() {
    this.applyCollapsedState()
    localStorage.setItem(this.storageKey, "true")
  }

  expand() {
    this.applyExpandedState()
    localStorage.setItem(this.storageKey, "false")
  }

  applyCollapsedState() {
    if (this.hasContentTarget) {
      this.contentTargets.forEach(content => content.classList.add("collapsed"))
    }

    if (this.hasIconTarget) {
      this.iconTargets.forEach(icon => icon.classList.add("collapsed"))
    }

    if (this.hasHeaderTarget) {
      this.headerTargets.forEach(header => header.classList.add("video-collapsed"))
    }

    if (this.hasLabelTarget) {
      this.labelTargets.forEach(label => label.classList.add("collapsed"))
    }
  }

  applyExpandedState() {
    if (this.hasContentTarget) {
      this.contentTargets.forEach(content => content.classList.remove("collapsed"))
    }

    if (this.hasIconTarget) {
      this.iconTargets.forEach(icon => icon.classList.remove("collapsed"))
    }

    if (this.hasHeaderTarget) {
      this.headerTargets.forEach(header => header.classList.remove("video-collapsed"))
    }

    if (this.hasLabelTarget) {
      this.labelTargets.forEach(label => label.classList.remove("collapsed"))
    }
  }
}
